import { flow, getOr } from 'lodash/fp';
import { connect } from 'react-redux';
import JobNotes from './JobNotes';

const mapStateToProps = ({ estimateBuilder }) => {
  const { entities, uiState } = estimateBuilder;
  const { estimates } = entities;
  const { selectedEstimate } = uiState;

  const estimate = estimates.byId[selectedEstimate];
  const notes = flow(
    getOr('[]', 'attributes.notes'),
    JSON.parse,
  )(estimate);

  return {
    notes,
  };
};

export default connect(mapStateToProps)(JobNotes);
